import React from 'react';

import SchoolList from './SchoolList';
import SchoolEditor from './SchoolEditor';
import AuthorizeRoute from '../api-authorization/AuthorizeRoute';

const SchoolPanel = () => (
  <>
    <AuthorizeRoute exact path='/admin/schools' component={SchoolList} />
    <AuthorizeRoute path='/admin/schools/:id' component={SchoolEditor} />
  </>
);

export default SchoolPanel;